import React from 'react';
import './ItemsList.scss';

interface ItemsListProps {
  items: string[];
  foundItems: string[];
}

const ItemsList: React.FC<ItemsListProps> = ({ items, foundItems }) => {
  const halfLength = Math.ceil(items.length / 2);
  const leftColumn = items.slice(0, halfLength);
  const rightColumn = items.slice(halfLength);

  return (
    <div
      className="items-list"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg.png)` }}
    >
      <div className="items-list__header">
        <h2 className="items-list__title">Holiday</h2>
        <h3 className="items-list__subtitle">SCAVENGER HUNT</h3>
        <p className="items-list__description">Find All The Items Listed To Win.</p>
      </div>
      <div className="items-list__columns">
        <div className="items-list__column">
          {leftColumn.map((item) => {
            const isFound = foundItems.includes(item);
            return (
              <div
                key={item}
                className={`items-list__item ${isFound ? 'items-list__item--found' : ''}`}
              >
                <span className="items-list__checkbox"></span>
                <span className="items-list__item-text">{item}</span>
              </div>
            );
          })}
        </div>
        <div className="items-list__column">
          {rightColumn.map((item) => {
            const isFound = foundItems.includes(item);
            return (
              <div
                key={item}
                className={`items-list__item ${isFound ? 'items-list__item--found' : ''}`}
              >
                <span className="items-list__checkbox"></span>
                <span className="items-list__item-text">{item}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ItemsList;
